import * as types from "./types";
import { combineReducers } from "redux";

function user(state = null, { type, payload }) {
  const { USER_LOGGED, ERROR, USER_LOGOUT } = types;
  return type === USER_LOGGED
    ? payload
    : type === ERROR || type === USER_LOGOUT ? null : state;
}

function loginError(state = null, { type, error }) {
  const { code } = error || "";
  const { signInErrorCodes } = types;

  return type === types.ERROR
    ? (signInErrorCodes.hasOwnProperty(code) && signInErrorCodes[code]) ||
        "Error Desconocido"
    : type === types.USER_LOGGED || type === types.RESET_ERROR ? null : state;
}

function connecting(state = false, { type, payload }) {
  return type === types.USER_LOGIN
    ? true
    : type === types.USER_LOGGED ? false : state;
}

function userIsAdmin(state = false, { type, payload }) {
  return type === types.USER_IS_ADMIN
    ? payload
    : type === types.RESET_USER_TYPE ? false : state;
}

function userIsNormal(state = false, { type, payload }) {
  return type === types.USER_IS_NORMAL
    ? payload
    : type === types.RESET_USER_TYPE ? false : state;
}

const reducer = combineReducers({
  user,
  loginError,
  connecting,
  userIsAdmin,
  userIsNormal
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/login/reducers.js